const state = {
    companyConfig: null,
    whiteStarValues: [],
    loading: false,
};

export default state;
